export const getChartSliceSizes = (data: number[]) => {
  const sorted = data.sort((a, b) => b - a);
  const max = sorted[0];
  const min = sorted[sorted.length - 1];

  return {
    counts: sorted,
    sliceSizes: sorted.map((value) => 20 + ((value - min) / (max - min)) * 80),
  };
};
